import { render, staticRenderFns } from "./RelationshipsAssets.vue?vue&type=template&id=2756be7c&"
import script from "./RelationshipsAssets.vue?vue&type=script&lang=js&"
export * from "./RelationshipsAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports